import React from 'react'
import LegacyChat from './components/LegacyChat.jsx'

export default function App() {
  return (
    <div className=''>
      {/* <div className='app-wrap'> */}

      <LegacyChat />
    </div>
  )
}
